import { Icon } from "@/components/icons";
import { Button } from "@/components/button";

const SUPPORT_URL = "https://help.sanctions.io/knowledge-base";

type Props = {
  insetLeft?: number;
};

export function NoActivePlanGate({ insetLeft = 0 }: Props) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="No active subscription plan"
      style={{ left: insetLeft }}
      className="fixed inset-y-0 right-0 z-[100] flex items-center justify-center bg-grey-900-24 p-4"
    >
      <div className="flex w-full max-w-[420px] flex-col items-center gap-4 rounded-[4px] border border-grey-200 bg-white p-6 text-center shadow-soft">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-[4px] border-t border-grey-900 bg-grey-950 text-grey-300 shadow-flat-black">
          <Icon name="lock" size={20} />
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-h4 text-black">No active plan</h2>
          <p className="text-small text-grey-900">
            Your company doesn&apos;t have an active subscription plan, so this feature is
            unavailable. Contact our support team to activate your plan.
          </p>
        </div>
        <Button hierarchy="primary" href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          Contact support
        </Button>
      </div>
    </div>
  );
}
